import { createAsyncThunk } from '@reduxjs/toolkit';

import { fetchCitiesSuggest, prepareSuggestions } from '@/microfrontends/filters/shared/services/fetchCitiesSuggest';
import { type TThunkApi } from '@/microfrontends/filters/shared/store';
import { type ILocation } from '@/microfrontends/filters/shared/types/location';

export const requestSuggestions = createAsyncThunk<ILocation[], string, TThunkApi>(
  'locationPopup/requestSuggestions',
  async (value, thunkApi) => {
    const { extra } = thunkApi;

    if (value.length < 2) {
      return [];
    }

    const suggestResponse = await fetchCitiesSuggest(extra, { text: value }, { subdomain: extra.custom.subdomain });

    return suggestResponse.map(prepareSuggestions).unwrapOr([]);
  },
);
